import {
  ToastContainer as ToastifyContainer,
  toast as toastifyToast,
  ToastOptions,
  Id,
} from "react-toastify";

import ToastMessage from "./ToastMessage";
import ToastCloseIcon from "./ToastCloseIcon";
import { IToastOptions } from "./types";

const ToastContainer: React.FC = () => {
  return (
    <ToastifyContainer
      hideProgressBar
      position="bottom-left"
      autoClose={30}
      draggablePercent={30}
      closeButton={ToastCloseIcon}
    />
  );
};

export default ToastContainer;

export const toast = (message: string, options?: IToastOptions) => {
  const {
    countdown,
    positiveCtaText,
    negativeCtaText,
    onPositiveCta,
    onNegativeCta,
    ...toastifyToastOptions
  } = options || {};
  const _toastifyToastOptions: ToastOptions = toastifyToastOptions;
  if (countdown) {
    _toastifyToastOptions.autoClose = false;
  }
  return toastifyToast(({ closeToast }) => {
    return (
      <ToastMessage
        message={message}
        countdown={countdown}
        positiveCtaText={positiveCtaText}
        negativeCtaText={negativeCtaText}
        onPositiveCta={onPositiveCta}
        onNegativeCta={onNegativeCta}
        closeToast={closeToast}
      />
    );
  }, _toastifyToastOptions);
};

export const dismiss = (id?: Id | undefined): void => toastifyToast.dismiss(id);
